import { useWorkshopCategories } from "@/lib/api";
import { MenuItem, Skeleton } from "@mui/material";
import PropTypes from "prop-types";
import SelectStyled from "../SelectStyled";

export const WorkshopCategorySelector = ({ name, label, onChange, ...props }) => {
    const { categories, isLoading, isError } = useWorkshopCategories();

    const handleSelected = (event) => {
        if (onChange) {
            onChange(event);
        }
    }

    if (isLoading) {
        return <Skeleton />
    }

    return (
        <>
            <SelectStyled
                fullWidth
                name={name}
                label={label}
                placeholder="Alle Workshops"
                variant="filled"
                inputProps={{ "aria-label": "Art des Workshops" }}
                onChange={handleSelected}
                renderValue={e => e?.name ?? "Alle Workshops"}
            >
                <MenuItem value="">Alle Workshops</MenuItem>
                {categories.map((category) => {
                    return <MenuItem key={category.id} value={category}>{category.name}</MenuItem>
                })}
            </SelectStyled>
        </>
    );
};

WorkshopCategorySelector.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func
};
